module.exports = __webpack_public_path__ + "static/media/Slots.70233468.svg";